import React, { MouseEvent, ReactElement, ReactNode, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Buttons, { Btn } from '../Buttons/Buttons';
import { ReactComponent as OpenIcon } from '../../assets/Icons/chevron/Chevron-Down.svg';
import { ReactComponent as CloseIcon } from '../../assets/Icons/chevron/Chevron-Up.svg';
import { ReactComponent as OpenNestedMenuIcon } from '../../assets/Icons/chevron/Chevron-Right.svg';
import { ReactComponent as DotsIcon } from '../../assets/Icons/adornments/Dots.svg';

export interface DropdownOption {
    label: string,
    action?: (e:MouseEvent<HTMLButtonElement>) => void | Promise<void>,
    btnComp?: ReactNode,
    startingAdornment?: ReactNode,
    moreOptions?: {
        label: string,
        action: (e:MouseEvent<HTMLButtonElement>) => void | Promise<void>,
        startingAdornment?: ReactNode,
    }[],
}


export default function Dropdown({ btn, options }: { 
    btn?: Btn,
    options: DropdownOption[],
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };



    return (
        <div>
            {btn ? (
                <Buttons 
                    type={btn.type}
                    styling={btn.styling}
                    id={btn.id}
                    label={btn.label}
                    endingAdornment={open ? <CloseIcon/> : <OpenIcon/>}
                    action={handleClick}
                />
            ) : (
                <button onClick={handleClick} className="text-disable hover:text-primary transition-all flex justify-center items-center">
                    <div className='w-[24px] h-[24px]'><DotsIcon/></div>
                </button>
            )} 
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                sx={{
                    marginTop: '8px',
                    '& .MuiMenu-list': {
                        padding: 0,
                    }
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '8px'
                        }
                    }
                }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                {options.map((option, i) => (
                    <MenuItem key={i} onKeyDown={(e) => e.stopPropagation()} sx={{
                        fontFamily: 'Montserrat',
                        fontWeight: 'medium',
                        color: `#35424A`,
                        backgroundColor: `#ffffff`,
                        // padding: '12px 20px',
                        padding: 0,
                    }} onClick={(e:any) => {option.action && option.action(e); e.stopPropagation()}}>
                        {option.btnComp ? (
                            <>
                            { option.btnComp = React.Children.map(option.btnComp, el => {
                                return React.cloneElement(el as ReactElement, { handleCloseMenu: handleClose })
                            })}
                            </>
                        ) : (
                        <button onClick={() => { handleClose(); console.log('button') }} className={`w-full px-5 py-3 text-left font-medium flex justify-between items-center gap-3 w-full h-full`}>
                            <div className='flex justify-start items-center gap-3'>
                                {option.startingAdornment && <div className='w-[18px] h-[18px]'>{option.startingAdornment}</div>}
                                <p className='text-nowrap'>{option.label}</p>
                            </div>
                            {option.moreOptions && <div className='w-[18px] h-[18px]'><OpenNestedMenuIcon/></div>}
                        </button>
                        )}
                    </MenuItem>
    
                ))}
            </Menu>
        </div>

    )
}